import {Server} from './server';

export const newsServer = new Server(process.env.REACT_APP_NEWS_SERVER_URL);

